const AccordionContainerParent = ({ children }: { children: React.ReactNode }) => {
  return <div className="flex flex-row gap-2 h-full">{children}</div>;
};

const AccordionContainer = ({ children }: { children: React.ReactNode }) => {
  return <div className="w-1/3 h-full p-2 bg-slate-50">{children}</div>;
};

const AccordionContainerSmall = ({ children }: { children: React.ReactNode }) => {
  return <div className="w-1/4 h-full p-2 bg-slate-50">{children}</div>;
};

export { AccordionContainer, AccordionContainerParent, AccordionContainerSmall };
